// 数值精准计算
import math from 'mathjs'

math.config({
  number: 'BigNumber',
  precision: 20
});

export default {
  install(Vue) {
    Vue.prototype.$math = math;
  }
}